import React from 'react';

interface LogoProps {
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className = 'h-8 w-auto' }) => {
  return (
    <div className="flex items-center">
      <div className="relative w-8 h-8">
        <div className="absolute inset-0 bg-gradient-to-r from-[#4b39ef] to-[#39d2c0] rounded-lg transform rotate-3"></div>
        <div className="absolute inset-0 bg-white dark:bg-gray-800 rounded-lg transform -rotate-3 flex items-center justify-center">
          <img src="/logo.svg" alt="TaskWave" className="w-6 h-6" />
        </div>
      </div>
      <span className="ml-2 text-xl font-bold bg-gradient-to-r from-[#4b39ef] to-[#39d2c0] text-transparent bg-clip-text">
        TaskWave
      </span>
    </div>
  );
};